import React from 'react';

const GridDotsBlankIcon: React.FC = () => (
  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3 2.5H3.00833M3 10H3.00833M3 17.5H3.00833M3 13.75H3.00833M3 6.25H3.00833M6.75 2.5H6.75833M6.75 10H6.75833M6.75 17.5H6.75833M14.25 2.5H14.2583M14.25 10H14.2583M14.25 17.5H14.2583M10.5 2.5H10.5083M10.5 10H10.5083M10.5 17.5H10.5083M10.5 13.75H10.5083M10.5 6.25H10.5083M18 2.5H18.0083M18 10H18.0083M18 17.5H18.0083M18 13.75H18.0083M18 6.25H18.0083"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default GridDotsBlankIcon;
